import { Box, Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import AdminPanelButton from "../../widgets/AdminPanelButton/AdminPanelButton";
import ProfileButton from "../../widgets/ProfileButton/ProfileButton";
import IconoCasosDeExito from "../../assets/Home/icon_success.svg";
import IllustrationBottomRight from "../../assets/Home/Home2.png";
import IconoConoce from "../../assets/Home/icon_other_ideas.svg";
import IllustrationTopLeft from "../../assets/Home/Home1.png";
import IconoTusIdeas from "../../assets/Home/icon_ideas.svg";
import CardBackground1 from "../../assets/Home/Card1.jpg";
import CardBackground2 from "../../assets/Home/Card2.jpg";
import CardBackground3 from "../../assets/Home/Card3.jpg";
import CardBackground4 from "../../assets/Home/Card4.jpg";
import ReachLogo from "../../assets/Logos/reach_logo.png";
import IconoNews from "../../assets/Home/icon_news.svg";
import { ILoggedUser } from "../../store/actions";
import { Position } from "../Login/LoginUtils";
import Grain from "../../assets/Grain.png";
import "./Home.scss";

export default function Home() {
	const navigator = useNavigate();

	const loggedUser: ILoggedUser = useSelector(
		(state: any) => state.loggedUser.loggedUser,
	);

	let cardItems = [
		{
			backgroundImage: CardBackground1,
			url: "/tus_ideas",
			cardIcon: IconoTusIdeas,
			title: "Tus ideas",
			description:
				"Las soluciones comienzan con ideas. ¡Comparte una idea con nosotros!",
		},
		{
			backgroundImage: CardBackground2,
			url: "/casos_exito",
			cardIcon: IconoCasosDeExito,
			title: "Casos de éxito",
			description: "Conoce nuestras ideas CHRISTUS.",
		},
		{
			backgroundImage: CardBackground3,
			url: "/conoce_ideas",
			cardIcon: IconoConoce,
			title: "Conoce otras ideas",
			description: "Conoce las ideas de otros colaboradores.",
		},
		{
			backgroundImage: CardBackground4,
			url: "/",
			cardIcon: IconoNews,
			title: "Conoce sobre Estrategia",
			description:
				"Conoce más sobre nuestra estrategia. Haz clic para ir al sitio.",
		},
	];

	// const { instance } = useMsal();
	// instance.logoutRedirect();
	// const dispatch = useDispatch();
	// dispatch(deleteLoggedUser);

	if (loggedUser.id !== 0)
		return (
			<Box className="home">
				<img
					className="home__grain"
					src={Grain}
					alt=""
				/>

				<img
					src={IllustrationTopLeft}
					alt=""
					width={"20%"}
					style={{
						zIndex: -1,
						position: "absolute",
						top: -1,
						left: -1,
					}}
				/>

				<img
					src={IllustrationBottomRight}
					alt=""
					width={"60%"}
					style={{ zIndex: -1, position: "absolute", bottom: -2, right: -2 }}
				/>

				<Box className="home__header">
					<img
						src={ReachLogo}
						alt="Reach 2030"
					/>

					<Box className="home__header__buttons">
						{loggedUser.position !== Position.COLAB && (
							<AdminPanelButton
								text={`Panel\nAdministrador`}
								route="/administrator"
							/>
						)}
						<ProfileButton />
					</Box>
				</Box>

				<Box className="home__container">
					{cardItems.map((item) => (
						<Button
							className="home__container__card"
							onClick={
								item !== cardItems[3]
									? () => navigator(item.url)
									: () =>
											window.open(
												"https://christusmx.sharepoint.com/sites/2025CONNECT",
												"_blank",
											)
							}
							style={{
								backgroundImage: `url(${item.backgroundImage})`,
							}}
						>
							<img
								src={item.cardIcon}
								alt=""
								width={"40%"}
							/>
							<Box>
								<Typography className="home__container__card__title">
									{item.title}
								</Typography>
								<Typography className="home__container__card__subtitle">
									{item.description}
								</Typography>
							</Box>
						</Button>
					))}
				</Box>
			</Box>
		);
	else
		return (
			<Box className="loader-overlay">
				<Box className="loader-container">
					<Box className="custom-loader" />
				</Box>
			</Box>
		);
}
